import { useContext } from 'react';
import { FeatureFlagKey } from 'services/statsig/types';
import { useStatsig } from 'shared/hooks/statsig/useStatsig';
import {
  EnvironmentContext,
  EnvironmentContextProps,
} from 'shared/providers/environment';

/**
 * Resolves the URL to use for a k8s auth service migration, returning the
 * new authV2Url when the provided feature flag is enabled and falling back
 * to the existing lambdaUrl otherwise.
 */
export function useAuthUrl(featureFlagKey: FeatureFlagKey) {
  const { currentEnv, getLambdaUrl, getV2AuthUrl } =
    useContext<EnvironmentContextProps>(EnvironmentContext);
  const { isFeatureEnabled } = useStatsig();

  const lambdaUrl = getLambdaUrl(currentEnv);
  const authV2Url = getV2AuthUrl(currentEnv);

  return isFeatureEnabled(featureFlagKey) ? authV2Url : lambdaUrl;
}

export default useAuthUrl;
